type IntegrationLike = {
    isValid?: boolean | null;
    status?: string | null;
    errors?: unknown;
};

export function hasIntegrationIssue(integration: IntegrationLike): boolean {
    if (integration.status === "error") {
        return true;
    }

    if (typeof integration.isValid === "boolean") {
        return !integration.isValid;
    }

    if (Array.isArray(integration.errors)) {
        return integration.errors.length > 0;
    }

    if (integration.errors && typeof integration.errors === "object") {
        return Object.values(integration.errors).some(Boolean);
    }

    return Boolean(integration.errors);
}
